import { api } from ".";
export const niceDecrypt = async (param)=>{
    let { tokenVersionId , encData  } = param;
    const { data  } = await api.post("/nice/decrypt", {
        tokenVersionId,
        encData
    });
    return data;
};
